import { Sparkles, ArrowUpRight } from "lucide-react";
import { aiRecommendations } from "../lib/mockData";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";

export default function AIRecommendations({ compact = false }) {
  return (
    <div
      data-testid="ai-recommendations"
      className="rounded-3xl border border-border/60 bg-gradient-to-br from-white to-accent/30 p-6 sm:p-8"
    >
      <div className="flex items-start justify-between gap-4 mb-6">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 text-primary px-3 py-1 text-xs font-semibold tracking-wide uppercase mb-3">
            <Sparkles size={12} /> AI Match Engine
          </div>
          <h3 className="font-display text-xl sm:text-2xl font-semibold text-foreground">
            Recommended for you
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            Smart matches based on your skills, location, and community activity.
          </p>
        </div>
        {!compact && (
          <div className="hidden sm:flex items-center gap-1 text-xs text-muted-foreground">
            <span className="h-2 w-2 rounded-full bg-secondary animate-pulse" />
            Live matching
          </div>
        )}
      </div>

      <div className="grid gap-3">
        {aiRecommendations.map((r, i) => (
          <div
            key={r.id}
            data-testid={`ai-rec-${r.id}`}
            className={`fade-up stagger-${i + 1} group rounded-2xl bg-white border border-border/60 p-5 hover:border-primary/40 hover:shadow-sm transition-all cursor-pointer`}
          >
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <Badge className="bg-secondary/15 text-secondary hover:bg-secondary/15 border-0 rounded-full text-[10px] px-2 py-0.5">
                    {r.matchType}
                  </Badge>
                  <Badge variant="outline" className="rounded-full text-[10px] px-2 py-0.5 border-border">
                    {r.category}
                  </Badge>
                </div>
                <h4 className="font-display font-semibold text-foreground truncate">{r.title}</h4>
                <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{r.reason}</p>
              </div>
              <div className="text-right shrink-0">
                <div className="text-2xl font-display font-bold text-primary leading-none">{r.score}</div>
                <div className="text-[10px] uppercase tracking-wider text-muted-foreground mt-1">match</div>
              </div>
            </div>
            <div className="flex justify-end mt-3">
              <Button
                size="sm"
                variant="ghost"
                className="rounded-full text-primary hover:bg-primary/5 group-hover:translate-x-0.5 transition-transform"
                data-testid={`ai-rec-cta-${r.id}`}
              >
                View <ArrowUpRight size={14} className="ml-1" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
